// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"a03178ae94487d8ec789","715":"6ebe6ec7d2dabcdfefc1","962":"b76c533fa8bad1a622dc"}[chunkId] + ".css";
};